import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import { CheckCircle, Mail, ArrowRight } from 'lucide-react';
import { trackPurchase } from '../utils/metaPixel';
import '../styles/Auth.css';

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const [purchaseTracked, setPurchaseTracked] = useState(false);
  
  useEffect(() => {
    // Track Purchase event on success page load
    // Get purchase details from URL params (set by Stripe redirect)
    if (!purchaseTracked) {
      const sessionId = searchParams.get('session_id');
      const amount = searchParams.get('amount');
      const courseId = searchParams.get('course_id');
      const courseName = searchParams.get('course_name');

      // Deterministic event_id — must match the server CAPI event_id sent from
      // the Stripe webhook (`purchase_{stripe_session_id}`) so Meta deduplicates
      // browser Pixel + server CAPI Purchase events.
      const deterministicEventId = sessionId ? `purchase_${sessionId}` : undefined;

      trackPurchase({
        value: amount ? parseFloat(amount) : 88, // Default price if not provided
        order_id: sessionId || `order_${Date.now()}`,
        content_id: courseId || 'cyber-privacy-security-basics',
        content_name: courseName || 'Cyber Privacy & Security Basics',
        event_id: deterministicEventId, // Deduplicate with server CAPI
      });
      
      setPurchaseTracked(true);
      console.log('[CheckoutSuccess] Purchase tracked:', { sessionId, amount, courseId });
    }
  }, [searchParams, purchaseTracked]);
  
  return (
    <>
      <Header />
      <div className="auth-page checkout-success-page">
        <div className="auth-container checkout-success-container">
          <div className="success-icon-wrapper">
            <CheckCircle size={64} className="success-icon-large" />
          </div>
          
          <h1>Payment Successful!</h1>
          
          <div className="success-message">
            <div className="email-notice">
              <Mail size={24} />
              <div>
                <h3>Check your email</h3>
                <p>We've sent you an email with a link to access your course.</p>
              </div>
            </div>
            
            <div className="success-details">
              <p>Your course access is ready. Click the link in your email to:</p>
              <ul>
                <li>Set up your password (new users)</li>
                <li>Access your course immediately</li>
              </ul>
            </div>
            
            <div className="success-note">
              <p>
                <strong>Gmail users:</strong> If you don't see the email in your Inbox, please check your <strong>"All Mail"</strong> folder and <strong>"Spam"</strong> folder.
              </p>
              <p style={{marginTop: '8px'}}>
                Still can't find it?{' '}
                <Link to="/request-access" className="text-link">
                  Request a new access link
                </Link>.
              </p>
            </div>
          </div>
          
          <div className="success-actions">
            <Link to="/" className="auth-secondary-btn">
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutSuccess;
